import FixedTermMaturityActionType from "@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityActionType";

export default (action: FixedTermMaturityActionType) => {
    let returnVal = "Undefined";
    switch (action) {
        case FixedTermMaturityActionType.Reinvest:
            returnVal = "Reinvest";
            break;
        case FixedTermMaturityActionType.Withdrawal:
            returnVal = "Withdraw";
            break;
    }
    return returnVal;
}